import ActionTypes from '../constants';

const initialState = {
    parallelJobs: {},
    parallelJob: {},
    // loading: false,
};

const parallelJobReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETPARALLELJOBSUCCESS:
            return {
                ...state,
                parallelJobs: action.payload,
            }
        case ActionTypes.GETPARALLELJOBBYIDSUCCESS:
            return {
                ...state,
                parallelJob: action.payload,
            }
        default:
            return state;
    }
}

export default parallelJobReducer;